@import 'styles/variables';

.container {
  align-items: center;
  background: var(--yellow-20);
  display: flex;
  gap: 10px;
  justify-content: center;
  left: 0;
  padding: 8px 10px;
  position: absolute;
  right: 0;
  top: 0;

  @media (max-width: $phoneMaxWidth) {
    min-height: 72px;
  }
}

.buttonContainer {
  background: var(--light-100);
  border-radius: 6px;
}
